import Button from "../components/button/Button"
import FAQItem from "../components/questions/Questions"
import Students from "../components/recommends/StudentsC";
import WhoFits from "../components/whoFits/WhoFits"
import styles from "./FifthScreen.module.css"

const FifthScreen = () => {
  return (
    <>
      <div className={styles.title}>שנייה לפני שאת ממשיכה הלאה</div>
      <div className={styles.description}>
        קל לדחות, לחשוב עוד קצת, לבדוק עוד אפשרויות...  
        אבל לפעמים מה שחסר זו רק ההחלטה לעשות צעד אחד קטן בשביל עצמך.
      </div>
      <div className={styles.description}>
        העתיד שאת רוצה מתחיל בהחלטה של עכשיו.  
        וזה בדיוק הזמן שלך לבחור בעצמך.
      </div>
      <div className={styles.description}>
        אם יש לך אמונה בעצמך ורצון לשמוע עוד <br/> תלחצי על הכפתור למטה, השאירי פרטים בטופס ואני אחייג אלייך לבדוק התאמה לנבחרת המנצחת שלי!
      </div>
      <Students/>
      <Button text="הצעד הראשון מתחיל בלחיצה כאן!"/>
      
      <div className={styles.title}>שאלות נפוצות</div>
      <div className={styles.description}>
        שנייה לפני שנדבר, אני בטוחה שעלו לך עוד כמה שאלות או חששות (וזה לגיטימי לגמרי).  
        לכן ריכזתי עבורך את כל מה שבנות שואלות לפני שהן נרשמות לקורסים שלי -  
        שאלות ששמעתי גם ממתעניינות, גם מתלמידות שכבר התחילו, וגם כאלה שאני בטוחה ששאלת את עצמך.
      </div>

      <FAQItem
        question="אין לי ניסיון – האם הקורס מתאים לי?"
        answer="בהחלט כן! הקורס נבנה במיוחד גם למי שמתחילה מאפס – בלי שום רקע, ניסיון או ידע קודם. אני מלמדת את הכול מהבסיס ועד לרמה הכי גבוהה – בשיטה סופר ברורה, שלב אחרי שלב, כולל תרגול מעשי צמוד. את תקבלי את כל הכלים, ההכוונה, והליווי שאת צריכה – כדי לצאת עם ביטחון ומקצוע ביד. בזכות השיטה שלי, תלמידות מתחילות עושות עבודות ברמה מקצועית כבר במהלך הקורס! אם יש לך רצון, אהבה ליופי ודיוק – אני כבר אדאג לכל השאר ❤️ אז כן – הקורס הזה בדיוק בשבילך."
      />

      <FAQItem
        question="כמה זמן לוקח עד שאוכל להרוויח מהקורס?"
        answer="ברוב המקרים, תלמידות שלי מתחילות להרוויח כבר במהלך הקורס – אחרי כמה מפגשים בלבד! השיטה שלי מדויקת ומעשית, ומאפשרת לך להוציא עבודות מקצועיות כבר מהר מאוד. כמובן, רמת ההכנסה תלויה במאמצים שלך, בהתמדה ובהתמקצעות, אבל עם הליווי והכלים שאני נותנת – ההכנסה יכולה להגיע לחמש ספרות בחודש בתוך תקופה קצרה יחסית. הכי חשוב? את יוצאת מהקורס עם מקצוע שלם, שכל כך מבוקש, שמאפשר לך לפתוח עסק עצמאי, לעבוד במכוני יופי או אפילו ללמד בעצמך. עם רצון נכון ושיטה מנצחת – ההצלחה כבר בדרך אלייך! ✨"
      />

      <FAQItem
        question="אני מפחדת שלא יהיה לי ביטחון להתחיל לעבוד אחרי הקורס – מה עושים?"
        answer="כל תלמידה מרגישה קצת חשש בהתחלה, וזה לגמרי נורמלי! בקורס שלי את לא לבד – אני מלמדת, מלווה ותומכת לאורך כל הדרך, גם אחרי שהקורס נגמר. במהלך הקורס תרכשי מיומנויות מקצועיות, תתרגלי המון – ותראי תוצאות מעולות כבר בזמן הלימודים. הביטחון מגיע עם ההצלחה הראשונה שלך, ואני כאן כדי להדריך אותך עד שתרגישי מוכנה ובטוחה 100%. הקורס כולל גם ליווי וייעוץ לאחר סיום, כדי לוודא שאת יוצאת לעבודה עם ראש שקט וידיעה שאת בידיים טובות. תזכרי – כל מקצוע חדש דורש קצת אומץ בהתחלה, אבל עם השיטה שלי והליווי שלי, תעשי את זה בקלות ובכיף! ❤️"
      />

      <FAQItem
        question="יש כל כך הרבה קורסים ביוטי – למה דווקא ציפורניים?"
        answer="תחום הציפורניים הוא אחד התחומים הכי חמים, יצירתיים ורווחיים בעולם היופי היום! עם ציפורניים את לא רק יוצרת יופי – את יוצרת אמנות שמשמחת את הלקוחות ומביאה לך הכנסה משמעותית. הייחוד שלי? אני מלמדת שיטה בלעדית, מקצועית, שמשלבת טכניקות חדשניות כמו מבנה אנטומי, לק ג'ל ובניית ציפורניים בג'ל ואקריל – מה שמקנה לך יתרון אמיתי בשוק התחרותי. בנוסף, התחום מאפשר לך גמישות עצומה – את יכולה לעבוד מהבית, במכון יופי, או אפילו לפתוח עסק משלך. והכי חשוב – זה תחום שמתפתח כל הזמן, עם טרנדים חדשים ואתגר יצירתי בכל יום. אז אם את רוצה מקצוע שכולו יצירה, רווח והגשמה – ציפורניים זו הבחירה הכי טובה!"
      />

      <FAQItem
        question="אין לי זמן, אני לומדת או עובדת – זה בכלל אפשרי?"
        answer="מבינה אותך לגמרי! החיים היום עמוסים, אבל בדיוק בשביל זה בניתי את הקורס שלי – גמיש, מקצועי ויעיל. הקורס מתקיים פעם בשבוע בשעות הבוקר, כל מפגש של 4 שעות, כך שאפשר להתאים את הלימודים לזמנים שנוחים לך. המטרה שלי היא לאפשר לך ללמוד מקצוע מנצח בלי לוותר על שאר התחומים בחיים. עם השיטה הייחודית שלי, תקבלי תוצאות מהר וביעילות, גם אם את עסוקה."
      />

      <FAQItem
        question="אני מתחת לגיל 18 - אני יכולה להירשם?"
        answer="רוב הקורסים שלי מיועדים לגיל 18 ומעלה, כי הם מקצועיים ומותאמים לבוגרים. אבל אם את מתחת לגיל 18, אפשר לבדוק אפשרות בהרשמה עם אישור והסכמה של ההורים, בתנאים מסוימים בלבד. חשוב לי שתלמדי במקום בטוח ומקצועי, אז תמיד נדבר עם ההורים ונוודא שהכל מתאים. אם תרצי, שלחי לי פרטים (גיל, מצב הלימודים, אם יש אישור הורים) ואבדוק איך הכי נכון ונוח לך להצטרף לקורס. אני כאן בשביל לעזור ולוודא שתקבלי את ההזדמנות הכי טובה ללמוד ולהצליח! ❤️"
      />

      <FAQItem
        question="אני מפחדת להשקיע כסף ולא לדעת אם אצליח..."
        answer="זה טבעי לחלוטין להרגיש ככה לפני השקעה משמעותית. אבל חשוב לזכור – הצלחה היא לא דבר שנולד איתנו, אלא תוצאה של למידה, התמדה ובחירה בדרך הנכונה. בקורס שלי תקבלי לא רק ידע מקצועי מעמיק, אלא גם ליווי אישי ותמיכה לאורך כל הדרך, עד שתרגישי בטוחה ומוכנה לעבוד. התלמידות שלי יוצאות עם כל הכלים והמוכנות להצליח – והן כבר רואות תוצאות בשטח בזמן הקורס! השקעה בעצמך היא הצעד הכי נכון שאת יכולה לעשות – כי כשאת משקיעה ביכולות שלך, את יוצרת לעצמך עתיד כלכלי חזק ובטוח. אני פה איתך לכל שאלה וליווי אישי, עד שתגיעי להצלחה שאת חולמת עליה!"
      />

      <Button text="יש לי עוד שאלות.." />
    </>
  );
};

export default FifthScreen;